function appendUTMParams(url, medium, source) {
  let campaign = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (!url) return url;
  const params = generateUTMParams(medium, source, campaign);
  try {
    const newUrl = new URL(url);
    var searchParams = newUrl.searchParams;
    Object.keys(params).forEach(key => {
      if (params[key] !== null) searchParams.set(key, params[key]);
    });
    newUrl.search = searchParams.toString();
    return newUrl.toString();
  } catch (e) {
    return url;
  }
}
function generateUTMParams(medium, source, campaign) {
  return {
    utm_medium: medium ? medium : 'social',
    utm_source: source ? source : 'campsite.bio',
    utm_campaign: campaign
  };
}
function canAddUTMParams(url) {
  return !/^(tel|sms|mailto):/.test(url);
}
export { appendUTMParams, canAddUTMParams, generateUTMParams };